import { gql } from 'apollo-angular';

export var update_tax_credits = gql`
  mutation updateProjectCredits($input: UpdateProjectCredits!) {
    updateProjectCredits(input: $input){
        projectCredits{
        id,amount, price, equity_amount, certificated, crea_syndicated,
        taxCreditType{
          id,name, level
        },
        taxCreditDesignation{
          id,name
        },
        projectCreditStatus{
          id,name
        }
        }
    }
  }
`;